import { cdn } from "../../../utils/cdn";

export const sectorPodlahy = {
  slug: "podlahy",
  locale: "sk",
  hero: {
    headlinePrefix: "Máte návštevníkov, ale ",
    headlineOriginal: "málo zákazníkov?",
    headlineReplacement: "zlý marketing?",
    subHeadline:
      "Zjednotíme váš marketing a privedieme na predajňu relevantných návštevníkov. Zvýšime vám predaje. Dlhodobo.",
    valueProps: [
      "Sme skúsení marketingoví experti",
      "Poznáme podrobne segment podláh",
      "Pracujeme maximálne transparentne",
    ],
    ctaLabel: "Zistite, ako vieme pomôcť",
    image: {
      src: "https://storage.googleapis.com/inaq_sk_pictures_landing_pages/assets/img/landing/podlahy/marketingova-agentura-podlahove-studio-predajna-s-podlahami-iq.avif",
      alt: "marketingova agentura podlahy predajna showroom s podlahami",
    },
    floating: {
      topLeft: { icon: "eye", label: "Viac relevantných návštevníkov" },
      bottom: { icon: "creditcard", label: "Viac reálnych kupujúcich" },
    },
  },
  bento: {
    headline: "Komplexné riešenie. Naozaj.",
    subHeadline: "Všetko, čo potrebujete pre úspešný marketing podláh",
    intro:
      "Ponúkame ucelený marketing pre podlahové štúdiá a predajne. Naše riešenia zvyšujú návštevnosť, konverziu a spokojnosť zákazníkov.",
    items: [
      {
        title: "Digital first prístup",
        description:
          "Komplexne nastavíme a optimalizujeme digitálne marketingové kanály pre vaše podlahové štúdio.",
        image: cdn("/assets/img/landing/podlahy/digital-first-strategy.avif"),
        alt: "Digital first prístup",
        className: "",
      },
      {
        title: "SEO pre podlahy",
        description:
          "Zlepšíme vašu viditeľnosť na internete a privedieme zákazníkov, ktorí prejavujú aktívny záujem o podlahy.",
        image: cdn(
          "/assets/img/landing/podlahy/socialne-siete-marketing-podlahy-predajne.avif"
        ),
        alt: "SEO pre podlahy",
        className: "",
      },
      {
        title: "UX dizajn",
        description:
          "Preveríme vašu webstránku a zlepšíme užívateľskú skúsenosť. Zlepšíme konverziu a zdvihneme predaje. ",
        image: cdn(
          "/assets/img/landing/podlahy/marketing-podlahy-fotenie-realizacii.avif"
        ),
        alt: "UX dizajn pre podlahy",
        className: "",
      },
      {
        title: "Online marketing",
        description:
          "Auditujeme súčasný rozpočet a alokáciu na PPC reklamy, sociálne siete a obsahový marketing. Vytlačíme maximum za vami investované peniaze.",
        image: cdn("/assets/img/landing/podlahy/marketing-showroom-podlahy.avif"),
        alt: "Marketing showroom podlahy",
        className: "col-span-2 sm:col-span-1",
      },
      {
        statistic: { number: "160+", label: "zrealizovaných marketingových kampaní za 12 rokov" },
        className: "",
      },
      {
        title: "Retail marketing",
        description:
          "Zjednotíme tlačoviny, POS materiály a všetko, s čím prichádza zákazník u vás na predajni do kontaktu. Tak, aby vaša komunikácia hrala offline aj online rovnako.",
        image: cdn(
          "/assets/img/landing/podlahy/marketingove-materialy-podlaha-predajna-podlah-grafika-tlac.avif"
        ),
        alt: "Lokálny marketing pre podlahy",
        className: "",
      },
      {
        title: "Marketingová stratégia",
        description:
          "Navrhneme komplexný plán na zvýšenie predaja a budovanie značky vášho podlahového štúdia. Cheme, aby ste boli profitabilní krátkodobo, no budovali si dlhodobú a stabilnú rentabilitu.",
        image: cdn(
          "/assets/img/landing/podlahy/obsahovy-marketing-pre-podlahy.avif"
        ),
        alt: "Marketingová stratégia pre podlahy",
        className: "col-span-2 sm:col-span-1",
      },
    ],
  },
  stdc: {
    eyebrow: "Pokrývame každú fázu",
    headline:
      "Uvedomujeme si, že 95% zákazníkov nenakupuje práve teraz. Cielime aj na nich.",
    intro:
      "Marketingové aktivity robíme v súlade s princípom modelu See Think Do Care. Aké sú výzvy v jednotlivých fázach a čo robíme pre ich zvládnutie?",
    items: [
      {
        icon: "eye",
        title: "Verejnosť v okolí netuší, že existujete",
        body:
          "Budujeme značku a komunikáciou zasahujeme okolie. Vytvárame povedomie o predajni tak, aby sa v neskoršej fáze vybavila v mysli záujemcov.",
      },
      {
        icon: "lightbulb",
        title: "Potenciálny záujemca nepríde pozrieť podlahu k vám",
        body:
          "Nadväzujeme na prvú fázu, ukazujeme ponuku a uľahčujeme nájdenie predajne. Vysvetľujeme, prečo by bola chyba nenavštíviť práve vás.",
      },
      {
        icon: "creditCard",
        title: "Návštevník u vás videl podlahu, ale nakúpil inde",
        body:
          "Auditujeme celý proces obsluhy na predajni, vrátane POS materiálov, s ktorými zákazník odchádza. Nastavíme komunikáciu po predložení ponuky.",
      },
      {
        icon: "loyalty",
        title:
          "Zákazník nakúpil, tým to končí. Žiadna referencia ani odporúčanie",
        body:
          "Maximalizujeme potenciál spokojných zákazníkov. Motivujeme k referencii, a tiež silnému predajnému kanálu - word of mouth.",
      },
    ],
  },
  faq: {
    headline: "Časté otázky",
    items: [
      {
        id: 1,
        question: "Pre aký typ predajne s podlahami sú vaše služby vhodné?",
        answer:
          "V princípe pre akýkoľvek. Avšak najviac z našej práce vyťažia väčšie predajne, ktoré už fungujú na trhu. My im pomôžeme celý marketing ujednotiť, vizuálne aj funkčne. Ideálne je, ak máte širší sortiment. To nám umožní nadefinovať profily zákazníkov a ich cestu.",
      },
      {
        id: 2,
        question: "Máte reálnu skúsenosť s marketingom pre predajňu podláh?",
        answer:
          "Áno. Vďaka tomu sme zorientovaní v ponuke. Vieme, aké sú najčastejšie bariéry pre rozhodnutie o nákupe zo strany návštevníka predajne. Máme technické znalosti a vieme na nich postaviť marketingové cesty. Vieme, ktorý sortiment komu ponúkať.  ",
      },
      {
        id: 3,
        question: "Viete mi spraviť web alebo e-shop?",
        answer: [
          "Máme technické znalosti na tvorbu, nie je to ale naša primárna oblasť špecializácie. Vieme vám zoptimalizovať procesy na webe smerujúce k návšteve predajne. Kampane pre nákup v e-shope prenecháme špecializovaným spoločnostiam.",
          "Určite ale viete, že v drvivej väčšine prebieha nákup na predajni, alebo minimálne je návšteva súčasťou. My preto cielime na vyladenie návštevy tak, aby ste zo záujemcov spravili zákazníkov.",
        ],
      },
      {
        id: 4,
        question:
          "Vaše služby vyjdú skoro rovnako ako náklad na full-time zamestnanca. Prečo mám dôverovať vám?",
        answer:
          "Máte prístup k expertíze naprieč množstvom oblastí. A skúsenosti, ktoré zväčša za priemerný náklad na full-time marketéra v oblasti podláh nezoženiete. A ak áno, potom narovinu - nepotrebujete nás.",
      },
      {
        id: 5,
        question: "Budem musieť podpísať dlhodobú zmluvu?",
        answer:
          "Nie. Začatie spolupráce zvažujeme dôkladne a dlhšie, to nám umožňuje ukončovať v prípade nespokojnosti rýchlo. Je to tak najlepšie pre obe strany. Zároveň je ale našim cieľom budovať dlhodobé spolupráce, z ktorých vyťažia obe strany.",
      },
    ],
  },
  cta: {
    headline: "Vyladíme vašu komunikáciu",
    body:
      "Máte dnes marketing nastavený tak, že neprichádzate o zákazníkov? Vyplňte krátky formulár a spolu pozrieme na to, ako vám vieme pomôcť.",
    buttonLabel: "Otvoriť formulár",
  },
  header: { ctaLabel: "Formulár za 60 sekúnd", brandLabel: "B2B marketingová agentúra" },
};

export default sectorPodlahy;
